import { del, get, set } from "idb-keyval";
import type {
	PersistedClient,
	Persister,
} from "@tanstack/react-query-persist-client";

export function createIDBPersister(idbValidKey: IDBValidKey = "reactQuery") {
	return {
		persistClient: (client: PersistedClient) => set(idbValidKey, client),
		restoreClient: () => get<PersistedClient>(idbValidKey),
		removeClient: () => del(idbValidKey),
	} satisfies Persister;
}
